import { hubService } from '@/services';
import { sortString } from '@/utils';
export default {
    async getHubs({ commit, rootGetters }) {
        const hubId = rootGetters['user/hubId'];
        const hubName = rootGetters['user/hubName'];
        const isDistUser = rootGetters['user/isDistUser'];
        const isPermissionOtherHub = rootGetters['user/isPermissionOtherHub'];
        // 다른 허브를 조회할 권한이 있는지 판단
        // 총판 계정 및 타허브조회권한이 있는 허브 계정의 경우 허브리스트 호출. disabled는 미들웨어 처리.
        if (isDistUser || isPermissionOtherHub) {
            const data = await hubService.getHubs({
                pageNumber: 1,
                pageSize: 1000,
                useYn: 'Y',
            });
            const optionsModel = data.list
                .map(({ name, code: id }) => ({
                key: id,
                text: name,
                value: {
                    type: 'HUB',
                    id,
                    hubId: id,
                    hubName: name,
                },
            }))
                .sort((a, b) => sortString(a.text, b.text))
                .filter((option) => option.value.id !== hubId);
            // 허브 리스트 정렬 정책에 따라 최상단에 본인 소속 허브를 등록합니다.
            // https://www.figma.com/file/7bANCHz9CK2Pjj1eNq3WXy/%EA%B3%B5%ED%86%B5?node-id=528%3A844&t=Z15LdJvnnxUgRh3g-0
            optionsModel.unshift({
                key: hubId,
                text: hubName,
                value: {
                    type: 'HUB',
                    id: hubId,
                    hubId,
                    hubName,
                },
            });
            commit('SET_HUBS', optionsModel);
            return;
        }
        const optionsModel = [
            {
                key: hubId,
                text: hubName,
                value: {
                    type: 'HUB',
                    id: hubId,
                    hubId,
                    hubName,
                },
            },
        ];
        commit('SET_HUBS', optionsModel);
    },
    /**
     * 임시 구독 허브
     * 임시 구독 허브는 상세 페이지에서 허브 셀렉터를 조회시 원치 않는 허브 정보가 되지 않도록
     * 임시적으로 설정해두는 허브다
     * 설정시 hubselect는 임시 값을 조회한다.
     * 임시 값을 제거 하면 다시 원복 된다.
     * @param
     */
    setTmpSubscribeHubInfo({ commit }, payload) {
        console.warn('구독 허브 임시값 설정. 초기화 필수');
        commit('SET_TMP_SUBSCRIBE_HUB_INFO', payload);
    },
    deleteTmpSubscribeHubInfo({ commit }) {
        console.warn('구독 허브 임시값 초기화 완료');
        commit('SET_TMP_SUBSCRIBE_HUB_INFO');
    },
    /**
     * 구독 허브 변경
     * @param payload 변경할 구독 허브 정보 배열
     */
    setSubscribeHubInfo({ commit }, payload) {
        commit('SET_SUBSCRIBE_HUB_INFO', payload);
    },
    /**
     * HubSelector 비활성화하기
     * @param {boolean}  비활성화 여부
     */
    setHubSelectorDisabled({ commit }, isDisabled) {
        commit('SET_HUB_SELECTOR_DISABLED', isDisabled);
    },
    /**
     * 선택한 허브의 위도, 경도 좌표 저장하기
     */
    async setSubscribeHubCoordinate({ commit }, hubId = '') {
        try {
            const { data } = await hubService.getSubscribeHubCoordinate(hubId);
            commit('SET_SUBSCRIBE_HUB_COORDINATE', data);
            return {
                isSuccess: true,
            };
        }
        catch (error) {
            const message = error.response?.data.error.message ?? error.message;
            const reason = error.response?.data.error.reason ?? error.reason;
            return {
                isSuccess: false,
                reason,
                message,
            };
        }
    },
};
